import React from 'react';
import forIn from 'lodash/forIn';
import ModalImage from "react-modal-image";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import isFunction from 'lodash/isFunction';

const PUBLIC_URL = process.env.PUBLIC_URL;
function formatUrl(options){
  let url = `${options.root}&`;
  const params = [];
  for(var key in options){
    if(key !== 'root') params.push(key + '=' + options[key].toString())
  }
  url += params.join('&');
  url = url +'&mode=tile&tilemode=gmap&tile={x}+{y}+{z}'
  return url;
}


class LayerServiceQGIS extends React.Component {
  constructor(props){
    super(props);
    this.renderLayerInfo = this.renderLayerInfo.bind(this);
  }
  renderLayerInfo() {
    const {layerInfo} = this.props;
    let content;
    let layerAttrs = {};
    // if(attributes && attributes.layerInfo) {
    //   layerAttrs = attributes.layerInfo;
    // }
    const lyrSrc = layerInfo.mapLayer.getSource();
    let url;
    let serviceType;
    let portalUrl;
    if(isFunction(lyrSrc.getParams)) {
      const layerParams = lyrSrc.getParams();      
      portalUrl= formatUrl(Object.assign({root: layerInfo.url}, layerParams));
    }else if(isFunction(lyrSrc.getUrls)) {
      url = lyrSrc.getUrls()[0];
      portalUrl= url   
    }
    
    const layerAttrsArr =[];
    
      if(portalUrl) {
        content =(
          <>
          <div style={{display:'flex', flexDirection:'column', marginLeft:'18px'}}>
          <label className="control-label" style={{marginTop:'16px'}} title="Copy the below url into the URL input for the XYZ Connection Menu.">Copy the below url into the URL input for the XYZ Connection Menu. </label>
            
            <div style={{display:'flex'}}>
                <h6 style={{marginTop:'6px', marginBottom:'6px'}}>
                QGIS XYZ Tiles Connection URL:
                </h6>
                 <CopyToClipboard text={portalUrl}>
                        <button style={{height:'32px', cursor:''}} className="btn btn-sm" id="basic-addon1"><i className={'mdi mdi-content-copy'} style={{cursor: 'pointer'}}/></button>
                      </CopyToClipboard>
                  <pre style={{marginLeft:'6px', padding: '16px', overflow: 'auto',fontSize: '85%', lineHeight: '1.45', backgroundColor: '#f6f8fa', borderRadius: '3px'}}>
                  {portalUrl}
                  </pre>
                  
                
               </div>
               <h5 style={{marginTop:'6px', marginBottom:'6px'}}>
                Detailed Instructions:
                </h5>
                <label className="control-label" style={{marginTop:'16px'}} title="Add to an Active Event">1. In the Browser right click XYZ Tiles </label>
              
              <ModalImage
                  style={{display:'block', width:'auto', height:'auto', maxWidth: '225px'}}
                  small={`./img/add-xyz-tiles-qgis_sm.png`}
                  large={`./img/add-xyz-tiles-qgis.png`}
                  hideDownload={true}
                  hideZoom={true}
                />
              <label className="control-label" style={{marginTop:'16px'}} title="Add to an Active Event">2. Select <i>New Connection</i>.</label>
              <ModalImage
                  style={{display:'block', width:'auto', height:'auto', maxWidth: '225px'}}
                  small={`./img/add-xyz-tiles-select-qgis_sm.png`}
                  large={`./img/add-xyz-tiles-select-qgis.png`}
                  hideDownload={true}
                  hideZoom={true}
                />
                <label className="control-label" style={{marginTop:'16px'}} title="Add to an Active Event">3. Copy the below url into the URL input for the URL in the XYZ Connection window.</label>
              
              <div style={{display:'flex'}}>
                 <CopyToClipboard text={portalUrl}>
                        <button style={{height:'32px', cursor:''}} className="btn btn-sm" id="basic-addon1"><i className={'mdi mdi-content-copy'} style={{cursor: 'pointer'}}/></button>
                      </CopyToClipboard>
                  <pre style={{marginLeft:'6px', padding: '16px', overflow: 'auto',fontSize: '85%', lineHeight: '1.45', backgroundColor: '#f6f8fa', borderRadius: '3px'}}>
                  {portalUrl}
                  </pre>
                  </div>
              <ModalImage
                  style={{display:'block', width:'auto', height:'auto', maxWidth: '225px'}}
                  small={`./img/add-xyz-connection-qgis_sm.png`}
                  large={`./img/add-xyz-connection-qgis.png`}
                  hideDownload={true}
                  hideZoom={true}
                />
            </div>
          </>
        )
      }else{
        content=(
          <>
            <div style={{display:'flex', flexDirection:'column', marginLeft:'18px'}}>
              Unable to generate the Url for ArcGIS Portal. Please Download the layer and manually add it to your viewer.
            </div>
            </>
        )
      }
      
    
    return content;
  }
  
  
  render(){
    return (
      <div style={{overflow:'hidden'}}>
        {this.renderLayerInfo()} 
      </div>
    )
  }
}

export default LayerServiceQGIS;
